import { UPDATE_NEW_LISTINGS } from "./actionTypes"

export const updateNewListings = count => {
  return {
    type: UPDATE_NEW_LISTINGS,
    payload: count,
  }
}
